import { csoCustomerOrder } from '@/api/ajax';

export const xiangmumingcheng = {
  id: 'xiangmumingcheng',
  key: 'projectId',
  tip: '项目名称',
  label: '项目名称',
  required: false,
  slot: 'ajaxSelect',
  ajax: csoCustomerOrder.listAllProjectForSelect,
  prop: {
    label: 'projectName',
    code: 'project_id'
  },
  ajaxQuery: 'projectName',
  // TODO: 需求是要支持多选，接口暂时不支持
  // multiple:true,
  width: 'auto'
};
export const renwuyuedu = {
  id: 'renwuyuedu',
  key: 'taskDt',
  width: 180,
  label: '任务月度',
  text: ['任务月度开始', '任务月度结束'],
  required: false,
  slot: 'date',
  format: 'yyyy-MM'
};
/******************************************************************************签约及合同管理*****************************************************************************/
// 钱包状态
export const WALLET_STATUS = {
  0: '未开户',
  1: '开户中',
  2: '已开户',
  3: '开户失败'
};

// 网银支付开户状态只有未开户已开户
export const WALLET_OFFLINEBANK_STATUS = {
  0: '未开户',
  2: '已开户'
};

// 实名认证状态
export const REALNAME_AUTH_STATUS = {
  0: '未认证',
  1: '已认证',
  2: '认证失败'
};

// 当前裞筹结构
export const TAX_RAISE_STRUCT = {
  1: '汇总申报',
  2: '委托代开',
  3: '委托代发',
  4: '运营基地',
  // 5: '个体',
  6: '委托代开(线上)',
  9: '工具'
};

// 合同一方的 签约状态
export const SIGN_STATUS = {
  '0': '未签约',
  '1': '签约中',
  '2': '已签约',
  '3': '签约失败'
};
export const ALL_SIGN_STATUS = {
  '-1': '未完成',
  '2': '已完成',
  '5': '已线下签约'
};
// 合同 总签约状态 展示
export const allSignStatusFieldResolve = v => {
  let val = +v;
  if (val === 2 || val === 5) {
    return ALL_SIGN_STATUS[val];
  } else {
    return ALL_SIGN_STATUS['-1'];
  }
};

// 供应商合同 总签约状态 查询
export const SUPPLIER_ALL_SIGN_STATUS = {
  '-1': '未完成',
  '2': '已完成'
};

// 供应合同 总签约状态 展示逻辑 2 和5 都是已完成，其他 未完成
export const supplierAllSignStatusFieldResolve = v => {
  let val = +v;
  if (val !== 2 && val !== 5) {
    return SUPPLIER_ALL_SIGN_STATUS['-1'];
  }
  return SUPPLIER_ALL_SIGN_STATUS['2'];
};

// 工业方 完成状态
export const INDUSTRY_TASK_STATUS = {
  0: '未完成',
  1: '已完成'
};

export const COLLECT_MONEY_TYPE = new Map([
  [1, '收入'],
  [2, '支出']
]);

export const MONEY_PLATFORM = new Map([
  [1, '银行卡'],
  [2, '钱包']
]);
export const INVOICE_STATUS = new Map([
  [0, '未开票'],
  [1, '已申请'],
  [2, '已完成'],
  [3, '无法开票']
]);
